module.exports = __webpack_public_path__ + "static/img/title.9fc2729.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicList/img/title/title.png
// module id = 497
// module chunks = 0